import type { Dayjs } from "@marekl/adminer/datetime";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiGet, apiPut, ApiError } from "../../lib/api";
import type { PaymentStatus } from "./teams";
import type { ID } from "../id";

export interface TeamPayment {
  team_id: ID;
  season_id: ID;
  season_code: string;
  status: PaymentStatus;
  paid_at?: Dayjs | null;
  amount_kc?: number | null;
  note: string;
}

export interface SetTeamPaymentPayload {
  status: PaymentStatus;
  paid_at?: string | null;
  amount_kc?: number | null;
  note?: string;
}

export function useTeamPayment(teamId: ID | undefined, seasonId?: ID) {
  const qs = seasonId ? `?season_id=${seasonId}` : "";
  return useQuery<TeamPayment>({
    queryKey: ["teams", teamId, "payment", seasonId ?? "active"],
    enabled: !!teamId,
    queryFn: () => apiGet<TeamPayment>(`/teams/${teamId}/payment${qs}`),
  });
}

export function useSetTeamPayment(teamId: ID) {
  const qc = useQueryClient();
  return useMutation<TeamPayment, ApiError, SetTeamPaymentPayload>({
    mutationFn: (payload) => apiPut<TeamPayment>(`/teams/${teamId}/payment`, payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["teams", teamId, "payment"] });
      qc.invalidateQueries({ queryKey: ["teams"] });
      qc.invalidateQueries({ queryKey: ["me", "teams"] });
    },
  });
}
